import { render, staticRenderFns } from "./ConfigBankAdm.vue?vue&type=template&id=5f870085"
import script from "./ConfigBankAdm.vue?vue&type=script&lang=js"
export * from "./ConfigBankAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports